import type { StyleRule } from '@archipro-design/aria';
import {
    pxArrayToRem,
    pxToRem,
    dividerClassName,
    buttonClassName,
    labelClassName,
} from '@archipro-design/aria';

export const Wrap: StyleRule = ({ theme }) => ({
    width: '100%',
    padding: pxArrayToRem([16, 0, 0, 0]),

    [theme.screen.laptop]: {
        padding: pxArrayToRem([0, 0, 32]),
        marginBottom: theme.siteVariables.spaces['space-40'],
    },

    [theme.screen.clamped]: {
        padding: pxArrayToRem([80, 0, 32]),
        margin: pxArrayToRem([0, -14]),
    },
});

export const SectionDivider: StyleRule = () => ({
    [`&.${dividerClassName}`]: {
        padding: 0,
    },
});

export const TileGrid: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        margin: pxArrayToRem([0, -14]),
    },
});

export const TitleWrap: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 18]),

    [theme.screen.laptop]: {
        padding: 0,
        marginBottom: pxToRem(26),
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridGap: pxToRem(20),
        [`& .${labelClassName}`]: {
            gridColumn: 2,
            textTransform: 'uppercase',
        },
    },
});

export const TileSlide: StyleRule = () => ({
    width: '100%',
    borderBottom: `1px solid rgba(52, 52, 52, 0.2)`,

    '&:last-child': {
        borderBottom: 'none',
    },
});

export const TileSlideWrap: StyleRule = () => ({
    width: '100%',
});

export const LoadMore: StyleRule = () => ({
    marginTop: pxToRem(66),
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: pxToRem(20),
    [`& .${buttonClassName}`]: {
        gridColumn: 2,
        padding: pxToRem(25),
        width: pxToRem(212),
        textTransform: 'uppercase',
    },
});
